import middleware from '@/lib/middleware'
import {Boot} from '@/project'

/**
 * Register middleware
 * @export default
 */
const boot: Boot = ({app, store, router}) => {
  middleware<any, any>({app, store, router}, {
    always: ['layout', 'after-layout'],
  })
}

export default boot
